import type {Claim} from '@deezer/next/services/api/Starmania/requests/claim/types';
import type {UserSettings} from '@deezer/next/services/types/userSettings';
import type {Feature} from '@deezer/next/services/types/features';
import type {AuthProvider} from '@deezer/next/services/api/Starmania/requests/auth/types';

export enum StakeholderType {
	PROVIDER = 0,
	LABEL_GROUP = 1,
	ARTIST_MANAGER = 2,
	ARTIST = 3,
	ARTIST_MARKETING = 4,
}

export type User = {
	id: number;
	email: string;
	name: string;
	stakeholderId: number;
	stakeholderType: StakeholderType;
	features: Feature[];
};

export type MyUser = User & {
	settings: UserSettings;
	uriRedirectionOnLogin: string;
	authProvider: AuthProvider;
};

export type SubLabel = {
	labelId: number;
	labelName: string;
	providerId: number;
	providerName: string;
	isProviderEnabled: boolean;
};

export type Profile = {
	id: number;
	name: string;
	picture: string;
	redirectUrl: string;
};

export type UserCreate = {
	id: number;
	email: string;
	name: string;
	stakeholderId: number;
	stakeholderType: number;
	features: Feature[];
	password: string;
	confirmationPassword: string;
};

export interface MainAppState {
	authToken: string;
	user?: MyUser;
	profiles: Profile[];
	claims: Claim[];
	isClaimsLoaded: boolean;
	artistId?: number;
}

// Action types
export enum MainAppStateActionType {
	SET_TOKEN = 'MainApp/SET_TOKEN',
	SET_USER = 'MainApp/SET_USER',
	SET_PROFILES = 'MainApp/SET_PROFILES',
	SET_CLAIMS = 'MainApp/SET_CLAIMS',
	SET_ACTIVE_ARTIST = 'MainApp/SET_ACTIVE_ARTIST',
}
// Actions
export interface MainAppTokenAction {
	type: MainAppStateActionType.SET_TOKEN;
	value: string;
}
export interface MainAppSetUserAction {
	type: MainAppStateActionType.SET_USER;
	user: MyUser | undefined;
}

export interface MainAppSetProfilesAction {
	type: MainAppStateActionType.SET_PROFILES;
	profiles: Profile[];
}

export interface MainAppSetClaimsAction {
	type: MainAppStateActionType.SET_CLAIMS;
	claims: Claim[];
}

export interface MainAppSetActiveArtistAction {
	type: MainAppStateActionType.SET_ACTIVE_ARTIST;
	artistId: number | undefined;
}

export type MainAppAction =
	| MainAppTokenAction
	| MainAppSetUserAction
	| MainAppSetClaimsAction
	| MainAppSetProfilesAction
	| MainAppSetActiveArtistAction;
